import React from 'react';
import cx from 'classnames';
import { Typography } from '@navi/web-ui/lib/primitives';
import VerticalSeperator from '@cp/src/components/VerticalSeperator';
import { PreAuditValue, PreAuditValuesProps } from '../../interface';
import { SOURCE_ICON_MAP } from '../../utils';
import PreAuditMoreButton from './PreAuditMoreButton';

const MAX_VISIBLE_ITEMS = 2;

const PreAuditValues: React.FC<PreAuditValuesProps> = ({ values, className, sourceOfValues }) => {
  if (!values.length) {
    return null;
  }

  const displayedValues = values.slice(0, MAX_VISIBLE_ITEMS);
  const hiddenValues = values.slice(MAX_VISIBLE_ITEMS);
  const hasMoreItems = hiddenValues.length > 0;

  return (
    <div
      className={cx(
        'm-3 p-2 bg-[var(--pale-yellow)] rounded-md flex flex-row items-center gap-2',
        className
      )}
    >
      {SOURCE_ICON_MAP[sourceOfValues]}
      <div className="flex flex-row flex-nowrap items-center gap-2">
        {displayedValues.map((value, index) => (
          <div key={value.id} className="flex items-center gap-2">
            <Typography
              variant="p3"
              color="var(--grayscale-2)"
              className="flex-shrink-0 whitespace-nowrap"
            >
              {value.label}
            </Typography>
            {(index < displayedValues.length - 1 || hasMoreItems) && (
              <VerticalSeperator height="17px" color="var(--grayscale-border-1)" />
            )}
          </div>
        ))}
        <PreAuditMoreButton hiddenValues={hiddenValues} />
      </div>
    </div>
  );
};

export default PreAuditValues;
